var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user.permission === 'adm_sys' && _vm.boUrl)?_c('div',{staticClass:"admin-actions"},[_c('span',[_c('a',{attrs:{"href":_vm.editUrl,"target":"_blank"}},[_c('action',{attrs:{"name":"link","nochevron":true,"small":true,"with-icon":"mdi-pencil","color-icon":"#0052FF"}},[_vm._v(" Modifer ")])],1)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }